<template>
    <page-content v-loading="loading" @contentScroll="contentScroll">
        <div slot="header">
            <!-- <h4>{{isOpen?'考核评分表填写':'该功能暂未开放'}}</h4> -->
            <h4>考核评分表填写</h4>
            <div v-if="isRole.includes(2) || isRole.includes(3)">
                <div v-for="(item,index) in buttList" :key="item" style="display: inline-block;margin-right:15px;">
                    <el-button v-show="!(!isRole.includes(1) && index==1)" @click="buttonClick(item)" class="header-button" size="mini" :style="buttsele===item?'background:#409EFF;color:#fff':''">{{item}}</el-button>
                </div>
            </div>
        </div>
        <div slot="content" style="position: relative;">
            <el-row v-show="(isRole.includes(2) || isRole.includes(3)) && buttsele=='组别/组员'" class="assess-tree">
                <el-col :span="3">
                    <el-tree
                        ref="formTree"
                        :data="assessmentList"
                        :props="defaultProps"
                        node-key="name"
                        accordion
                        :highlight-current="true"
                        @node-click="handleNodeClick"
                        v-loading="loading">
                    </el-tree>
                </el-col>
                <div  class="assess-tree-box"></div>
                <el-col :span="18" :offset="1">
                    <el-table :data="tableData" style="width: 1000px" :default-sort = "{prop: 'date', order: 'descending'}">
                        <el-table-column header-align="center" align="center" prop="name_en" sortable label="名称" width="100">
                        </el-table-column>
                        <el-table-column header-align="center" align="center" prop="group_name" sortable label="组别" width="200">
                        </el-table-column>
                        <el-table-column header-align="center" align="center" prop="position_name" sortable label="职位" width="200">
                        </el-table-column>
                        <el-table-column header-align="center" align="center" prop="template_name_created_by" sortable label="考核表" width="200">
                        </el-table-column>
                        <el-table-column header-align="center" align="center" prop="is_examinee_confirmed" sortable label="是否已填考核表" width="150">
                            <template slot-scope="scope">
                                <i :class="(scope.row.is_examinee_confirmed || scope.row.is_examinee_confirmed)?'el-icon-check':'el-icon-close'"></i>
                            </template>
                        </el-table-column>
                        <el-table-column header-align="center" align="center" prop="operation" label="操作">
                            <template slot-scope="scope">
                                <el-button :disabled="setOperation(scope)" 
                                @click="operationClick(scope)" type="text" size="mini">操作</el-button>
                                <el-button @click="examineCLick(scope)" type="text" size="mini">查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <div>
                <div v-if="(!!!isOpen && currentHistorical) && buttsele!='组别/组员'">本期考核评分暂未开放，可查看往期分数</div>
                <div v-else-if="is_attendance==0 && buttsele !='组别/组员'">
                    暂不参加考核评分
                </div>
                <assessFormWrite
                    v-show="buttsele!='组别/组员' && (isOpen || (!isOpen && !currentHistorical && isCheck)) && (is_attendance == 1)"
                    ref="write"
                    :isRole="role"
                    :isCheck="isCheck"
                    :isExaminers="isExaminer"
                    :buttsele="buttsele"
                    @attendanceChang="attendanceChang"
                    @historical="getHistoricalData"
                    @buttonClick="buttonClick"
                    @getAssessmentList="getAssessmentList">
                </assessFormWrite>
                <historicalCard v-show="buttsele!='组别/组员'" ref="historical" @historical="historical"></historicalCard>
            </div>
        </div>
    </page-content>
</template>
<script>
import pageContent from '@/components/pageContent'
import { computeAssessDate } from '@/assets/js/date.js'
import assessFormWrite from '@/page/assessFormWrite/assessFormWrite'
import historicalCard from './components/historicalCard'
export default {
    data(){
        return {
            assessmentList:[],              //负责人或者考评人的评分表树状格式
            collapse: false,
            loading:false,
            tableData: [],
            role:[],
            isRole:[],                      //1-被考评人，2-考评人，3-负责人
            buttList:['组别/组员','个人考核表'],
            buttsele:'组别/组员',
            defaultProps: {
                children: 'childrens',
                label:'name'
            },
            isTree:true,
            isCheck:false,                  //是否为查看
            isOpen:true,                    //功能是否开放
            isExaminer:false,               //是否为考评人，用于个人考核表提交查询组员是否已全部提交
            keyName:'',                     //tree选中名
            staff_id:'',
            isHistoryCheck:false,           //是否为历史查看
            is_attendance:true,             //是否参加本期考核
            currentHistorical:true,         //历史是否为本期
        }
    },
    created(){
        if(JSON.stringify(this.$route.query) == '{}'){
            this.loading=true;
			this.getIsOpen()
        }
    },
    methods:{
        getIsRole(role){	//判断是否为考评人或负责人
			const params={
				params:{
					start:computeAssessDate()[0].split('/')[0],
					end:computeAssessDate()[0].split('/')[1],
					staff_id:this.$store.state.login.userinfo.id,
					role:role,
				}
            }
			this.$http.get('/assessment/isRole',params).then((v)=>{ //判断当前角色
				if(v.status === 200){
					if(role<3) this.getIsRole(role+1);
                    if(v.data.status)this.isRole.push(role);

					if(role ===3 && (this.isRole.includes(2) || this.isRole.includes(3))){
                        const { params:{role,...data} } = params;
                        this.getAssessmentList(data)
                    }
                    
                    if(role >= 3 && this.isRole.includes(1) && this.isRole.length===1){ //只作为被考评人
                        const { params:{role,...data} } = params;
                        this.$refs.write.initData(data,'/assessment/getOneByStaff')
                        this.$refs.historical.initData(this.$store.state.login.userinfo.id); //往期得分
                        this.buttsele=false;
                    }
                    this.role=this.isRole;
                }
			}).catch(()=>{})
        },
        getAssessmentList(param){	//获取作为负责人或者考评人的评分表
			this.$http.get('/assessment/getAssessmentListMeInChargeAsTree',{params:param}).then((v)=>{
				if(v.status === 200){
                    this.assessmentList=Array.from(v.data.data);
                    if(this.keyName){   //默认显示数据
                        const assessment=this.assessmentList.find(v=>v.name === this.keyName);
                        this.handleNodeClick(assessment)
                    }else{
                        this.handleNodeClick(this.assessmentList[0])
                    }
                    setTimeout(()=>{
                        this.$refs.formTree.setCurrentKey(this.keyName?this.keyName:v.data.data[0].name); //tree默认选中
                    },200)
				}
			}).catch(()=>{})
        },
        handleNodeClick(data) {            //列表点击
            this.keyName=data.name;
            this.tableData=data.children;
        },
        operationClick(scope){                   //操作
            this.buttsele=false;
            this.isCheck=false;
            this.isHistoryCheck=false;
            this.is_attendance=1;
            this.setLeaderHead();
            if(this.isRole.includes(2) && !this.isRole.includes(3)){     //为考评人
                this.role=[2];
            }
            if(this.isRole.includes(2) && this.isRole.includes(3)){
                this.role=[2,3];
            }
            this.$nextTick(()=>{
                this.assessmentInitData(scope.row.staff_id);
            })
        },
        examineCLick(scope){            //查看
            this.buttsele=false;
            this.isCheck=true;
            this.isHistoryCheck=true;
            this.is_attendance=1;
            this.role=[1];
            this.setLeaderHead();
            this.$nextTick(()=>{
                this.assessmentInitData(scope.row.staff_id);
            })
        },
        buttonClick(v){ //tab
            this.buttsele=v;
            this.isCheck=false;
            this.isHistoryCheck=false;
            this.is_attendance=1;
            if(v === '个人考核表' && this.isRole.includes(1)){  //填写个人考核表
                this.role=[1];
                this.assessmentInitData()
            }
            this.setLeaderHead();
        },
        assessmentInitData(id){
            if(this.isRole.includes(2) || this.isRole.includes(3)){ //考评人,负责人填写个人考核表
                this.isExaminer=true;
            }else{
                this.isExaminer=false;
            }
            const  params={
                    start:computeAssessDate()[0].split('/')[0],
                    end:computeAssessDate()[0].split('/')[1],
                    staff_id:id?id:this.$store.state.login.userinfo.id,
                }
            this.staff_id=id?id:this.$store.state.login.userinfo.id;
            this.$nextTick(()=>{
                this.$refs.write.initData(params,'/assessment/getOneByStaff');
                this.$refs.historical.initData(id?id:this.$store.state.login.userinfo.id); //往期得分
            })
        },
        getIsOpen(){    //判断功能是否开放  1-互评填写 2-考核评分表填写
            const param={
                start:computeAssessDate()[0].split('/')[0],
                end:computeAssessDate()[0].split('/')[1],
                department_id:this.$store.state.login.userinfo.department_id,
                flow_type:2,
            }
            this.$http.get('/flow/isOpen',{params:param}).then(v=>{
                if(v.status === 200){
                    this.isOpen=v.data.status;
                    this.loading=false;
                    this.getIsRole(1);
                    // if(v.data.status) this.getIsRole(1);
                }
            }).catch(v=>{this.loading=false;})
        },
        setOperation({row}){    //操作限制
            if(this.isRole.includes(2) && this.isRole.includes(3)){         //同时负责人和考评人
                if(row.is_examinee_confirmed === 0 || row.is_leader_confirmed === 1){
                    return true;
                }else{
                    return false;
                }
            }else if(this.isRole.includes(3)){    //负责人
                if(row.is_leader_confirmed === 1){ //提交
                    return true;
                }else if(row.is_examinee_confirmed===0 || row.is_examiner_confirmed===0){   //手下没有填写
                    return true;
                }else{
                    return false;
                }
            }else if(this.isRole.includes(2)){  //考评人
                if(row.is_examiner_confirmed === 1){
                    return true;
                }else if(row.is_examinee_confirmed === 0){
                    return true;
                }else{
                    return false;
                }
            }
            return false;
        },
        //往期得分
        getHistoricalData(){
            this.$refs.historical.initData(this.staff_id?this.staff_id:this.$store.state.login.userinfo.id); //往期得分
        },
        //往期得分
        historical(param){
            const  params={
                    start:param.start,
                    end:param.end,
                    staff_id:this.staff_id?this.staff_id:this.$store.state.login.userinfo.id
                }
            if(computeAssessDate()[0].split('/')[0]!=params.start && computeAssessDate()[0].split('/')[1]!=params.end){ //不是本期
                this.isCheck=true;
                this.currentHistorical = false;
            }else{
                this.currentHistorical = true;
                if(this.isHistoryCheck){
                    this.isCheck=true;
                }else{
                    this.isCheck=false;
                }
            }
            this.$refs.write.getInitData(params,'/assessment/getOneByStaff');
        },
        //是否参加考核
        attendanceChang(v){
            this.is_attendance=v;
        },
        //内容滚动
        contentScroll(e){
            const scrollTop = e.target.scrollTop;
            if(scrollTop > 0){
                this.$refs.write.contentScroll(true);
            }else{
                this.$refs.write.contentScroll(false);
            }
        },
        setLeaderHead(){
            if(this.isRole.includes(2) || this.isRole.includes(3)){
                this.$refs.write.setLeaderHead(true);
            }else{
                this.$refs.write.setLeaderHead(false);
            }
        }
    },
    components:{
        assessFormWrite,
        pageContent,
        historicalCard
    }
}
</script>
<style scoped>
    .assess-tree{
        position: relative;
    }
    .assess-tree-box{
        height: 98%;
        border-right: 1px solid #DCDFE6;
        position: absolute;
        left: 240px;
        top: 1%;
    }
    .header-button{
        margin: 15px 0;
    }
    .el-icon-check,.el-icon-close{
        font-size: 20px;
        color: #f56c6c;
    }
    .el-icon-check{
        color: #67c23a;
    }
</style>
